import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { HttpError, SLOIgnoreHttpError } from '../../common/utils/error';
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';

/**
 * @deprecated migrate to generated types
 */

/**
 * @deprecated migrate to generated types
 */

/**
 * @deprecated migrate to generated types
 */

var V1_URL = '/teams/v1';
var SENTRY_IGNORED_ERROR_MESSAGES_CREATE = ['TEAM_NOT_FOUND'];
export var PublicApiClient = /*#__PURE__*/function (_RestClient) {
  _inherits(PublicApiClient, _RestClient);
  var _super = _createSuper(PublicApiClient);
  function PublicApiClient(serviceUrlRoot) {
    _classCallCheck(this, PublicApiClient);
    return _super.call(this, {
      serviceUrl: serviceUrlRoot
    });
  }
  _createClass(PublicApiClient, [{
    key: "addUsersToTeam",
    value: function () {
      var _addUsersToTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(teamId, members) {
        var missingMembersError, membersWithIds, _missingMembersError, orgId, url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!members || members.length === 0)) {
                _context.next = 4;
                break;
              }
              missingMembersError = new Error('Missing members to add');
              this.logException(missingMembersError, 'addUsersToTeam');
              throw missingMembersError;
            case 4:
              membersWithIds = members.filter(function (member) {
                return !!member.accountId;
              });
              if (membersWithIds.length !== members.length) {
                this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
              }
              if (!(membersWithIds.length === 0)) {
                _context.next = 10;
                break;
              }
              _missingMembersError = new Error('Missing accountIds for all members');
              this.logException(_missingMembersError, 'addUsersToTeam');
              throw _missingMembersError;
            case 10:
              _context.prev = 10;
              orgId = this.getOrgId();
              url = "".concat(V1_URL, "/org/").concat(orgId, "/teams/").concat(teamId, "/members/add");
              _context.next = 15;
              return this.postResource(url, {
                members: membersWithIds
              });
            case 15:
              response = _context.sent;
              return _context.abrupt("return", response);
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](10);
              this.logException(_context.t0, 'addUsersToTeam');
              if (!(_context.t0 instanceof HttpError && SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(_context.t0.message))) {
                _context.next = 24;
                break;
              }
              throw new SLOIgnoreHttpError(_context.t0);
            case 24:
              throw _context.t0;
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[10, 19]]);
      }));
      function addUsersToTeam(_x, _x2) {
        return _addUsersToTeam.apply(this, arguments);
      }
      return addUsersToTeam;
    }()
  }, {
    key: "removeTeamMemberships",
    value: function () {
      var _removeTeamMemberships = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(teamId, members) {
        var missingMembersError, membersWithIds, _missingMembersError2, orgId, url, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!members || members.length === 0)) {
                _context2.next = 4;
                break;
              }
              missingMembersError = new Error('Missing members to remove');
              this.logException(missingMembersError, 'removeTeamMemberships');
              throw missingMembersError;
            case 4:
              membersWithIds = members.filter(function (member) {
                return !!member.accountId;
              });
              if (membersWithIds.length !== members.length) {
                this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
              }
              if (!(membersWithIds.length === 0)) {
                _context2.next = 10;
                break;
              }
              _missingMembersError2 = new Error('Missing accountIds for all members');
              this.logException(_missingMembersError2, 'removeTeamMemberships');
              throw _missingMembersError2;
            case 10:
              _context2.prev = 10;
              orgId = this.getOrgId();
              url = "".concat(V1_URL, "/org/").concat(orgId, "/teams/").concat(teamId, "/members/remove");
              _context2.next = 15;
              return this.postResource(url, {
                members: membersWithIds
              });
            case 15:
              response = _context2.sent;
              return _context2.abrupt("return", response);
            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](10);
              this.logException(_context2.t0, 'removeTeamMemberships');
              throw _context2.t0;
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[10, 19]]);
      }));
      function removeTeamMemberships(_x3, _x4) {
        return _removeTeamMemberships.apply(this, arguments);
      }
      return removeTeamMemberships;
    }()
  }, {
    key: "getTeamDetails",
    value: function () {
      var _getTeamDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(teamId) {
        var orgId, url, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              orgId = this.getOrgId();
              url = "".concat(V1_URL, "/org/").concat(orgId, "/teams/").concat(teamId);
              _context3.next = 5;
              return this.getResource(url);
            case 5:
              response = _context3.sent;
              return _context3.abrupt("return", response);
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              this.logException(_context3.t0, 'getTeamDetails');
              throw _context3.t0;
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 9]]);
      }));
      function getTeamDetails(_x5) {
        return _getTeamDetails.apply(this, arguments);
      }
      return getTeamDetails;
    }()
  }, {
    key: "getTeamMembers",
    value: function () {
      var _getTeamMembers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(teamId) {
        var first,
          after,
          orgId,
          url,
          response,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              first = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 50;
              after = _args4.length > 2 ? _args4[2] : undefined;
              _context4.prev = 2;
              orgId = this.getOrgId();
              url = "".concat(V1_URL, "/org/").concat(orgId, "/teams/").concat(teamId, "/members");
              _context4.next = 7;
              return this.postResource(url, {
                after: after,
                first: first
              });
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", response);
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](2);
              this.logException(_context4.t0, 'getTeamMembers');
              throw _context4.t0;
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 11]]);
      }));
      function getTeamMembers(_x6) {
        return _getTeamMembers.apply(this, arguments);
      }
      return getTeamMembers;
    }()
  }, {
    key: "restoreTeam",
    value: function () {
      var _restoreTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(teamId) {
        var orgId, url;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              orgId = this.getOrgId();
              url = "".concat(V1_URL, "/org/").concat(orgId, "/teams/").concat(teamId, "/restore");
              return _context5.abrupt("return", this.postResource(url));
            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](0);
              this.logException(_context5.t0, 'restoreTeam');
              throw _context5.t0;
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 6]]);
      }));
      function restoreTeam(_x7) {
        return _restoreTeam.apply(this, arguments);
      }
      return restoreTeam;
    }()
  }]);
  return PublicApiClient;
}(RestClient);

// eslint-disable-next-line import/no-anonymous-default-export
export default new PublicApiClient(DEFAULT_CONFIG.publicApiRoot);